import { render } from "./ModalGlobalDiscount.vue?vue&type=template&id=f3f9724a"
import script from "./ModalGlobalDiscount.vue?vue&type=script&lang=js"
export * from "./ModalGlobalDiscount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__